import { useEffect, useState } from 'react';
import serverErrorHandler from 'services/serverError.service';
import { FileType } from 'rsuite/esm/Uploader';
import { openSuccessToaster } from 'services/toast.service';
import { SclaApplication } from 'features/scla/types';
import removeSclaAppLetterOfRec from '../api/removeSclaAppLetterOfRec';

export default function useUpdateSclaAppLetterOfRec(
  app: SclaApplication,
  setApplication: (val: SclaApplication) => void,
) {
  const [isLoading, setIsLoading] = useState(false);
  const [files, setFiles] = useState<FileType[]>([]);

  useEffect(() => {
    const { recInfo } = app;

    setFiles(
      recInfo.files.map((item: any) => ({
        name: item.originalName,
        url: item.url,
        fileKey: item._id,
        status: 'finished',
        progress: 100,
      })),
    );
  }, [app]);

  const onError = (e: any) => {
    if (e.response) {
      serverErrorHandler({ response: { data: e.response } });
    } else {
      serverErrorHandler(e);
    }
    setIsLoading(false);
  };

  const onSuccess = (response: any) => {
    setApplication({
      ...app,
      recInfo: response.payload.recInfo,
    });
    openSuccessToaster('File uploaded.', 3000);
    setIsLoading(false);
  };

  const onRemove = async (file: FileType) => {
    try {
      setIsLoading(true);
      const response = await removeSclaAppLetterOfRec(app._id, {
        fileId: `${file.fileKey}`,
      });

      setApplication({
        ...app,
        recInfo: response.recInfo,
      });
      setIsLoading(false);
      openSuccessToaster(`Removed file.`, 3000);
    } catch (e) {
      // hide spinner
      setIsLoading(false);
      serverErrorHandler(e);
    }
  };

  return {
    setIsLoading,
    isLoading,
    files,
    onError,
    onSuccess,
    onRemove,
  };
}
